import React from 'react';
import faqData from '../data/faqData.json';

interface FAQItem {
  id: string;
  question: string;
  answer?: string;
  filePath?: string;
  linkURL?: string;
  hidden?: boolean;
}

const FAQList: React.FC = () => {
  return (
    <div className="faq-list">
      <h1>Frequently Asked Questions about Weight Loss Medications</h1>
      <ul>
        {(faqData as FAQItem[])
          .filter(item => !item.hidden)
          .map(item => (
            <li key={item.id}>
              <a href={item.linkURL ? item.linkURL : `/faq/${item.id}`}>{item.question}</a>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default FAQList;
